module.exports = __webpack_public_path__ + "static/media/42_B.f6bc7b7b.png";